<template>
  <div class="user-profile container">
    <div class="user-info">
      <span class="user-name">
        <router-link v-if="!logined" to="/login">您好，请<span class="ns-text-color">登录</span></router-link>
        <span v-else>欢迎，<strong>{{ member.nickname || member.username }}</strong></span>
      </span>
      <div class="user-buttons" style="margin-left: 20px;">
        <router-link to="/member/order_list">我的订单</router-link>
        <router-link to="/member/footprint">我的足迹</router-link>
        <router-link to="/member/collection">我的关注</router-link>
        <router-link to="/member/my_coupon">我的优惠卷</router-link>
      </div>
    </div>
    <div class="other-buttons">
      <span style="font-weight: 700;margin:0px 10px;">商城服务:</span>
      <a :href="shopApplyUrl">招商入驻</a>
      <a :href="shopCenterUrl">商家中心</a>
      <a v-if="addonIsExit.store == 1" :href="storeUrl">门店管理</a>
    </div>
  </div>
</template>

<script>
import Config from "@/utils/config"
import { mapGetters } from 'vuex';
export default {
  name: 'memner-info',
  data: () => ({
    shopApplyUrl: Config.baseUrl + "/shop/login/register",
    shopCenterUrl: Config.baseUrl + "/shop/index/index",
    storeUrl: Config.baseUrl + "/store",
  }),
  computed: {
    ...mapGetters(["addonIsExit", "member"]),
    logined: function () {
      return this.member !== undefined && this.member !== "" && this.member !== {}
    }
  }

};
</script>

<style lang="scss">
.user-profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #ffffff;
  margin: 20px 0;
  border-radius: 8px;

  .user-info {
    display: flex;

    .user-name {
      max-width: 200px;
      white-space: nowrap;
      /* 强制内容在一行内显示 */
      overflow: hidden;
      /* 隐藏超出部分 */
      text-overflow: ellipsis;
      /* 溢出部分显示省略号 */
    }
  }

  .user-buttons a {
    // color: $base-color!important;
  }

  .user-buttons a,
  .other-buttons a {
    // color: #333;
    text-decoration: none;
    margin: 0 10px;
    font-weight: 500;
  }

  .user-buttons a:hover,
  .other-buttons a:hover {
    text-decoration: underline;
    color: $base-color !important;
  }
}
</style>
